<template>
<div>
	

            
            <div v-for="(editable, editableIndex) in editables" class="card mb-3">
                <div class="card-header">
                    <div class="row">
                      <div class="col">
                        <h4 class="pt-1 mb-0">Entry: {{ editableIndex }} <a class="float-right btn btn-danger" @click="removeEntry(editableIndex)"><i class="fa fa-trash"></i></a></h4>
                      </div>
                    </div>
                </div>
                <div class="card-body">            
					<div v-for="(entry, entryIndex) in editable" class="form-row mb-3">
					    <div class="form-group col-2">
					    	<input type="text" :name="'entry['+editableIndex+'][]'" v-model="entryIndex" class="form-control">
					    </div>
					    <div class="form-group col">
					    	<input type="text" :name="'entryContent['+editableIndex+']['+entryIndex+']'" v-model="editable[entryIndex]" class="form-control">
					    </div>
					    <div class="form-group col-1"><a class="btn btn-danger" @click="removeEntryRow(editableIndex,entryIndex)"><i class="fa fa-minus"></i></a></div>   
					</div>                            
                </div> 
                <div class="card-footer">
                	<a class="float-right btn btn-success" @click="addEntryRow(editableIndex)"><i class="fa fa-plus"></i></a>
                </div>
            </div>                           
            

            
            <div class="text-right"><a class="btn btn-success mb-5" @click="addEntry()">Add Entry <i class="fa fa-plus"></i></a></div>
     


</div>
</template>
 
<script>
import axios from 'axios';

    export default {
        mounted() {
          
          this.csrfToken = $('meta[name="csrf-token"]').attr('content');       
          if(!this.formelementTemplateId == ''){
            this.getEditable();
          }
          

        },
        updated(){

        },
        components: {

        },
        props: [
            'id',
        ],
        data: function(){

            return {
                formelementTemplateId: this.id,
                editables: new Array,
            }
        },

        methods: {

          getEditable: function(){
          	var vm = this;

            axios.get('/admin/formelement-template/get/'+vm.formelementTemplateId).then(response => {

              vm.editables = response.data.editable;

            }).catch(() => console.warn('Oh. Something went wrong. getEditable'));

          },
          addEntry: function(){
            this.editables.push(new Object);
          },
          removeEntry: function(editableIndex){
            this.$delete(this.editables,editableIndex);
          },
          addEntryRow: function(editableIndex){
            this.$set(this.editables[editableIndex],'','');
          },
          removeEntryRow: function(editableIndex,entryIndex){
            this.$delete(this.editables[editableIndex],entryIndex);
          },
        }
    }

</script>